import type { CustomThemeConfig } from '@pba/react-theme';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { useResolveSpacingValue } from '../hooks';
import styles from './wrapper.module.css';

export type WrapperProperties = {
  marginHorizontal?: SpacingValue;
  marginVertical?: SpacingValue;
  paddingHorizontal?: SpacingValue;
  paddingVertical?: SpacingValue;
} & ComponentProps<'div'>;

type SpacingValue = keyof CustomThemeConfig['spacing'];

const Wrapper = ({
  className,
  marginHorizontal,
  marginVertical,
  paddingHorizontal,
  paddingVertical,
  style,
  ...rest
}: WrapperProperties) => {
  const resolveSpacingValue = useResolveSpacingValue();

  const toCss = (value?: SpacingValue) => (value === undefined ? undefined : `${resolveSpacingValue({ value })}px`);

  return (
    <div
      className={cn(className, styles.wrapper)}
      style={{
        ...style,
        ['--wrapper-margin-horizontal' as string]: toCss(marginHorizontal),
        ['--wrapper-margin-vertical' as string]: toCss(marginVertical),
        ['--wrapper-padding-horizontal' as string]: toCss(paddingHorizontal),
        ['--wrapper-padding-vertical' as string]: toCss(paddingVertical),
      }}
      {...rest}
    />
  );
};

export default Wrapper;
